package com.wintermar.inspection.navigation

import androidx.navigation3.runtime.NavKey
import kotlinx.serialization.Serializable

@Serializable
sealed interface Route : NavKey {
    val showTopBar: Boolean get() = false

    @Serializable
    data object Splash : Route, NavKey

    @Serializable
    data object NotFound : Route, NavKey

    @Serializable
    data object Auth : Route, NavKey {
        @Serializable
        data object Login : Route, NavKey {
        }
    }

    @Serializable
    data object Template : Route, NavKey {
        @Serializable
        data object List : Route, NavKey {
            override val showTopBar: Boolean = true
        }
    }

    @Serializable
    data object Inspection : Route, NavKey {
        @Serializable
        data object List : Route, NavKey {
            override val showTopBar: Boolean = true
        }

        @Serializable
        data class Answer(val inspectionId: String) : Route, NavKey {
        }

        @Serializable
        data object SearchQuestion : Route, NavKey

        @Serializable
        data object CompleteAnswer : Route, NavKey

        @Serializable
        data object Complete : Route, NavKey
    }

    @Serializable
    data object Logout : Route, NavKey {
        override val showTopBar: Boolean = true
    }

}
